import * as React from "react";
const SvgHome = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "-1.1 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 20V6.667L8.944 0l8.833 6.667V20h-6.5v-7.917H6.472V20Z" }));
export default SvgHome;
